import type { FaireProductEntity } from "../../entity_types/product";

export const atc_toast_1: FaireProductEntity = {
  token: "atc_toast_1",
  type: "product",
  name: "Linen Tea Towel — Sage",
  brandName: "Sunday Edition",
  imageUrl: "",
  priceDollars: 10.0,
  msrpDollars: 22.0,
  description: "Migrated search/ATC mock product",
  tags: ["search", "prototype"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
